import * as Immutable from 'immutable';
import {createAction} from 'redux-actions';
import {actionTypes as system} from "../System";
import {handleActions} from '../../Utility/HandleActions';

//
// actionTypes
//
const SAGA_LOAD_DATA_START = "DBM/DATA/SETTLEMENT/SAGA_LOAD_DATA_START";
const SAGA_LOAD_DATA_SUCCESS = "DBM/DATA/SETTLEMENT/SAGA_LOAD_DATA_SUCCESS";

const CHANGE_FIXING_DATE = 'DBM/DATA/SETTLEMENT/FIXING_DATE';
const CHANGE_HISTORICAL_RATE_MONTH = 'DBM/DATA/SETTLEMENT/CHANGE_HISTORICAL_RATE_MONTH';
const CHANGE_HISTORICAL_RATE_YEAR = 'DBM/DATA/SETTLEMENT/CHANGE_HISTORICAL_RATE_YEAR';

export const actionTypes = {
    SAGA_LOAD_DATA_START,
    SAGA_LOAD_DATA_SUCCESS,
    CHANGE_FIXING_DATE,
    CHANGE_HISTORICAL_RATE_MONTH,
    CHANGE_HISTORICAL_RATE_YEAR
};

//
// Create actions
//
const sagaLoadDataStart = createAction(SAGA_LOAD_DATA_START);
const sagaLoadDataSuccess = createAction(SAGA_LOAD_DATA_SUCCESS);
const changeFixingDate = createAction(CHANGE_FIXING_DATE, date => ({date}));
const changeHistoricalRateMonth = createAction(CHANGE_HISTORICAL_RATE_MONTH, date => ({date}));
const changeHistoricalRateYear = createAction(CHANGE_HISTORICAL_RATE_YEAR, date => ({date}));

export const actions = {
    sagaLoadDataStart,
    sagaLoadDataSuccess,
    changeFixingDate,
    changeHistoricalRateMonth,
    changeHistoricalRateYear
};

export const reducer = handleActions({
    [system.INIT]: () => {
        return (state) => {
            let newState = state;
            newState = newState.setIn(['data', 'settlement', 'table'], Immutable.fromJS({}));
            newState = newState.setIn(['data', 'settlement', 'fixingdate'], new Date());
            newState = newState.setIn(['data', 'settlement', 'historicalRateMonth'], new Date());
            return newState;
        }
    },

    [SAGA_LOAD_DATA_START]: () => {
        return (state) => {
            return state.setIn(['data', 'settlement', 'table'], Immutable.fromJS({}));
        }
    },

    [SAGA_LOAD_DATA_SUCCESS]: (data) => {
        return (state) => {
            return state.setIn(['data', 'settlement', 'table'], Immutable.fromJS(data));
        }
    },

    [CHANGE_FIXING_DATE]: (payload) =>
        (state) => {
            return state.setIn(['data', 'settlement', 'fixingdate'], payload.date);
        }
    ,

    [CHANGE_HISTORICAL_RATE_MONTH]: (payload) =>
        (state) => {
            return state.setIn(['data', 'settlement', 'historicalRateMonth'], payload.date);
        }
    ,

    [CHANGE_HISTORICAL_RATE_YEAR]: (payload) =>
        (state) => {
            return state.setIn(['data', 'settlement', 'historicalRateYear'], payload.date);
        }
    ,

});

const getData = (state) => state.getIn(['data', 'settlement', 'table']).toJS();
const getFixingDate = (state) => state.getIn(['data', 'settlement', 'fixingdate']);
const getHistoricalRateMonth = (state) => state.getIn(['data', 'settlement', 'historicalRateMonth']);
const getHistoricalRateYear = (state) => state.getIn(['data', 'settlement', 'historicalRateYear']);

export const selectors = {
    getData,
    getFixingDate,
    getHistoricalRateMonth,
    getHistoricalRateYear
};
